import { transform } from './CO';

export const transformData = (data, country) => {
  if (country === 'CO') return transform(data);
  return data;
};
